'use strict';

module.exports.POSITION_AT_SHORTHAND = {
  first: 0,
  second: 1,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/cssstyle/lib/constants.js
// module id = 3HlP
// module chunks = 0